var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.finalClass},[_vm._t("default",function(){return [_c('i',{staticClass:"fas fa-spin fa-circle-notch"}),(!_vm.emptySlot)?_c('span',{staticClass:"ml-2"},[_vm._v("Loading..")]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }